<template>
  <div>
    <video id="tvideo" style="width: 100%;height:200px" playsinline webkit-playsinline></video>
  </div>
</template>
<script>
import { getVideoPara } from '@/api/shopapi'
export default {
    name: "TcPlayerW",
    props:{
      file_id:{
        type:String,
        required: true
      },
      auto: {
        type: Boolean,
        required: false,
        default: false
      },
      newFlag: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        player:{},
        index:0
      }
    },
    mounted () {
      console.log('init tplayer')
      this.playVideo()
    },
    methods:{
      nextVedio(){
        this.index++
        this.playVideo()
      },
      async playVideo(){
        if(this.player && this.player.dispose){
          this.player.dispose()
        }
        let para={}
        if(this.newFlag){
           para={ta_id: this.file_id,app_id:'1312783541' }
        }else{
           para={file_id:this.file_id }
        }
        console.log('filePara',para)
        const {code,message, data} = await getVideoPara(para)
      //  const {code,message, data} = await getVideoPara({ta_id: this.idList[this.index].toString(),app_id:'1312783541' })
        if (code === 0) {
          const options = {
            fileID: data.file_id,
            appID: data.app_id,
            psign: data.super_player_sign,
            autoplay: this.auto,
            plugins: {
              HLSToken: {
                token: data.dk_token
              }
            }
          }
          setTimeout(()=>{
            this.player = TCPlayer('tvideo', options)
            const _this = this
            this.player.ready(function(){
              console.log('ready')
              _this.player.on('ended',function(){
                console.log('ended tvideo')
                _this.$emit('ended',_this.player)
              })
              _this.player.on('play',function(){
                console.log('play tvideo')
                _this.$emit('play',_this.player)
              })
            })
          }, 100)
        }else{
          this.$toast.fail(code + message)
        }
      }
    },
    beforeDestroy () {
      console.log('dispose tplayer')
      if(this.player && this.player.dispose){
        this.player.dispose()
      }
    }
}
</script>
